import React from "react";

import { MILLIONS_OF_ICONS } from "core/constants";

// components
import OptionLabel from "./OptionLabel";

// icons
import Icon from "core/ReusableIcons/Icon";
import IconSets from "core/ReusableIcons/Collections";
import Photo from "core/ReusableIcons/Photo";

// constants
export const ICONS_SEARCH_ID = 1;
export const ICON_SETS_SEARCH_ID = 2;
export const PHOTOS_SEARCH_ID = 3;

// Placeholders
const icons = `Search nearly ${MILLIONS_OF_ICONS} million icons`;
const defaultPlaceholders = {
    icons,
    iconCollections: icons,
    photos: "Search art-quality photos",
};

// Responsive override for the global header and homepage hero search bars only.
// See sc-81564: icons landing page keeps the old copy at all breakpoints.
export const headerHomePlaceholder = {
    desktop: `Search ${MILLIONS_OF_ICONS}M icons & icon sets in any style`,
    tablet: defaultPlaceholders.icons,
    mobile: defaultPlaceholders.icons,
};

export const getDropDownOptions = placeholderOverride => {
    let icons = {
        id: ICONS_SEARCH_ID,
        searchParamKey: "icons",
        placeholder: placeholderOverride ?? defaultPlaceholders.icons,
        option: <OptionLabel text="Icons" Icon={Icon} />,
        controlLabelOverride: <OptionLabel text="Icons" Icon={Icon} hideTextOnMobile />,
        label: "Icons",
    };

    let iconSets = {
        id: ICON_SETS_SEARCH_ID,
        searchParamKey: "icon-collections",
        placeholder: placeholderOverride ?? defaultPlaceholders.iconCollections,
        option: <OptionLabel text="Icon Sets" Icon={IconSets} />,
        controlLabelOverride: (
            <OptionLabel text="Icon Sets" Icon={IconSets} hideTextOnMobile />
        ),
        label: "Icon Sets",
    };
    let photos = {
        id: PHOTOS_SEARCH_ID,
        searchParamKey: "photos",
        placeholder: defaultPlaceholders.photos,
        option: <OptionLabel text="Photos" Icon={Photo} />,
        controlLabelOverride: <OptionLabel text="Photos" Icon={Photo} hideTextOnMobile />,
        label: "Photos",
    };

    return [icons, iconSets, photos];
};

const getSelectedOption = (options, searchType) => {
    return options.find(o => o.searchParamKey === searchType) || options[0];
};

export const getDropDownProps = ({ searchType = "icons", placeholderOverride }) => {
    const options = getDropDownOptions(placeholderOverride);
    const selectedOption = getSelectedOption(options, searchType);
    return {
        activeSearchType: searchType,
        selectedOption,
        options,
    };
};
